module.exports = __webpack_public_path__ + "img/icon-printer.4937fba6.svg";